import GeneralSchema from "@/Config/Export/CreateNewJob/GeneralDetailsSchema";
import { mapExporterRequest } from "@/redux/mappers/Export/CreateNewJob/generalMapper";
import Sezinfo from "@/Config/Export/CreateNewJob/Sezinfo/Sezschema3";
import EntitySchema from "@/Config/Export/CreateNewJob/Entity/EntityCustomizedList";
import ContainerSchema from "@/Config/Export/CreateNewJob/Container/Containerformpop.jsx";
import ShipmentMainjson from "@/Config/Export/CreateNewJob/Shipment/ShipmentMain";
import ExbondDetailsSchema from "@/Config/Export/CreateNewJob/Shipment/ExbonddetailsPopup";
import ShipmentStuffingDetails from "@/Config/Export/CreateNewJob/Shipment/ShipmentStuffingDetails";
import ShipmentInvoicePrintJson from "@/Config/Export/CreateNewJob/Shipment/ShipmentInvoicePrint";
import InvoiceSummaryCard from "@/Views/ExportJob/CreateNewJob/InvoiceTab/InvoiceSummaryCard";
import ProductTabBox from "@/Views/ExportJob/CreateNewJob/Product/ProductTabBox";
import ProductMain from "@/Config/Export/CreateNewJob/ProductJsons/ProductMain";
import ProductOther from "./ProductJsons/ProductOtherinfo";
import ProductGeneral from "./ProductJsons/ProductGeneral";
import ProductDrawTop from "./ProductJsons/ProductDrawTop";
import InvoiceDialog from "@/Config/Export/CreateNewJob/Invoice/InvoiceTable";
import InvoiceBuyer from "@/Config/Export/CreateNewJob/Invoice/InvoiceBuyer";
import InvoiceOtherDetails from "@/Config/Export/CreateNewJob/Invoice/InvoiceOtherInfo";
import Udf from "@/Config/Export/CreateNewJob/Udf/Udf";
import Trackingschema from "../../../Config/Export/CreateNewJob/Tracking/Tracking";

import ProductJobWork from "./ProductJsons/ProductJobWork";
import ProductReExportSchema from "@/Config/Export/CreateNewJob/ProductJsons/ProductReExport";
import ProductQuota from "@/Config/Export/CreateNewJob/ProductJsons/ProductQuota";
import ProductARE from "./ProductJsons/ProductARE";
import ShipingBillPrinting from "./Shipment/ShipingBillPrinting";
import Control from "@/Config/Export/CreateNewJob/ProductJsons/ProductControlpop";
import productiondetails from "@/Config/Export/CreateNewJob/ProductJsons/ProductProductionpop";
import ProductDUCInfo from "./ProductJsons/ProductDUCInfo";

import ProductDOCInfo from "./ProductJsons/ProductDOCInfo";
import Note from "./Notes/Note";
import ProductSinglewindowpop from "./ProductJsons/ProductSinglewindowpop";
import ProductConsititpop from "./ProductJsons/ProductConsititpop";
import ProductDEPBjson from "./ProductJsons/ProductDEPBjson";
import ProductDEPBpopjson from "./ProductJsons/ProductDEPBpopjson";
import ProductSanchit from "./eSanchit/ProductSanchit";
import Requirement from "./Requirement/Requirement";
import { LuSearch } from "@/Components/Icons/Icons";
import ProductDRFC from "./ProductJsons/ProductDRFC";
import ProductDRFCjson from "./ProductJsons/ProductDRFCjson";
import Annexdetails from "./Shipment/Annexdetails";
import AnnexPopupJson from "./Shipment/AnnexPopupJson";
import { mapDEPBRequest } from "@/redux/mappers/Export/CreateNewJob/DEPBMapper";
import ProductSanchitFilter from "./eSanchit/ProductSanchitFilter";
import Tracking from "../../../Views/ExportJob/CreateNewJob/Tracking";
import {mapMilestoneToApi} from "../../../redux/mappers/Export/CreateNewJob/mapMilestoneToApi"
import {
  depbVisibleData,
  dfiaVisibleData,
  drawBackVisibleData,
  epcgVisibleData,
  deecVisibleData,
} from "@/Constant/Common/Common";
import ProductDEECTable1 from "./ProductJsons/ProductDEECTable1";
import ProductDEECTable2 from "./ProductJsons/ProductDEECTable2";
import ProductDEECForm from "./ProductJsons/ProductDEECForm";
import ProductEPCGForm from "./ProductJsons/ProductEPCGForm";
import ProductEPCGTable1 from "./ProductJsons/ProductEPCGTable1";
import ProductEPCGTable2 from "./ProductJsons/ProductEPCGTable2";
import ProductDFIAForm from "./ProductJsons/ProductDFIAForm";
import ProductDFIATable1 from "./ProductJsons/ProductDFIATable1";
import ProductDFIATable2 from "./ProductJsons/ProductDFIATable2";


// import InvoiceMain from "@/Config/Export/CreateNewJob/Invoice/invoiceBuyer";

export const CreateNewJobSidebarItems = (formData,eximData) => {

  const hasJobNumber = formData?.general?.exporterJobNumber ?? false;
 const hasInvoiceMain = (formData?.invoiceMain?.length ?? 0) > 0;
const isInvoiceAvailable = formData?.general?.isInvoiceAvailable === true;

const hasInvoice = hasInvoiceMain ? true : isInvoiceAvailable;
  const hasProduct = formData?.productMain?.length != 0 ? true : false;

  const selectedInvoice =
    formData?.invoiceMain?.find((invoice) => invoice?.selected === true) ||
    null;

const selectedMain = Array.isArray(formData?.productMain)
  ? formData.productMain.find((item) => item.selected)
  : null;

const eximCodeId =
 selectedMain?.eximCode ||  "";

  const eximCodeObj = eximData?.find((item) => item.id === eximCodeId);

  const eximCode = eximCodeObj?.name || "";
  
  const firstInvoice = formData?.invoiceMain?.[0];
  const currencyName = firstInvoice?.exportCurrency?.name || "";

  return [
    {
      id: "general",
      label: "General",
      disabled: false,
      schema: GeneralSchema,
      api: "exporter",
      type: "form",
      mapper: mapExporterRequest,
    },
    {
      id: "entity",
      label: "Entity",
      disabled: !hasJobNumber,
      api: "entity",
      type: "table",
      schema: EntitySchema,
      buttons: [
        {
          label: "Add New Entity",
          icon: "LuPlus",
          action: "openForm",
        },
      ],
      visibleFields: [
        { key: "exportEntityType", label: "Type", width: 100 },
        { key: "exportEntityName", label: "Name", width: 150 },
        { key: "exportEntityState", label: "State", width: 150 },
        { key: "exportEntityMobile", label: "Mobile", width: 150 },
        { key: "exportEntityAddress", label: "Address", width: 250 },
        { key: "exportEntityCountry", label: "Country", width: 150 },
        { key: "exportEntityCity", label: "City", width: 150 },
      ],
      expandedFields: [
        { key: "exportEntityFax", label: "Fax", width: 100 },
        { key: "exportEntityPostalCode", label: "Postal Code", width: 100 },
        {
          key: "exportEntityContactPerson",
          label: "Contact Person",
          width: 100,
        },
        { key: "exportEntityEmail", label: "Email", width: 100 },
        { key: "exportEntityTelephone", label: "Telephone", width: 100 },
      ],
    },

    {
      id: "sezInfo",
      label: "SEZ Info",
      schema: Sezinfo,
      type: "form",
      api: "sez",
      disabled: true,
    },
    {
      id: "shipment",
      label: "Shipment",
      disabled: !hasJobNumber,
      type: "tab",
      subTabs: [
        {
          id: "shipmentMain",
          label: "Main",
          type: "form",
          api: "mainShipment",
          schema: ShipmentMainjson,
        },
        {
          id: "shipmentStuffingDetails",
          label: "Stuffing Details",
          type: "form",
          schema: ShipmentStuffingDetails,
          api: "shipmentStuffing",
        },
        {
          id: "shipmentInvoicePrinting",
          label: "Invoice Printing",
          type: "form",
          schema: ShipmentInvoicePrintJson,
          api: "shipmentinvoiceprint",
        },
        {
          id: "shipmentShippingBillPrinting",
          label: "Shipping Bill Printing",
          type: "form",
          schema: ShipingBillPrinting,
          api: "shipmentbillprint",
        },
        {
          id: "shipmentExbondDetails",
          label: "Ex-Bond Details",
          type: "table",
          schema: ExbondDetailsSchema,
          api: "shipmentExBondDetails",
          buttons: [
            {
              label: "Add New Ex-Bond Details",
              icon: "LuPlus",
              action: "openForm",
            },
          ],
          visibleFields: [
            { key: "exportShipmentExBondBENo", label: "BE No", width: 150 },
            { key: "exportShipmentExBondBEDate", label: "BE Date", width: 170 },
            { key: "exportShipmentExBondVessel", label: "Vessal", width: 150 },
            { key: "exportShipmentExBondVoyage", label: "Voyage", width: 150 },
            { key: "exportShipmentExBondIGMNo", label: "IGM No", width: 150 },
          ],
          expandedFields: [
            {
              key: "exportShipmentExBondGMDate",
              label: "IGM Date",
              width: 100,
            },
            {
              key: "exportShipmentExBondNoOfPackage",
              label: "No Of Pkg",
              width: 100,
            },
            { key: "exportShipmentExBondNo", label: "Bond No", width: 100 },
            { key: "exportShipmentExBondDate", label: "Bond Date", width: 100 },
            {
              key: "exportShipmentExBondWareHouse",
              label: "Ware House",
              width: 100,
            },
          ],
        },
        {
          id: "shipmentAnnexC1Details",
          label: "Annex C1 Details",
          type: "formWithTable",
          api: "shipmentAnnuxForm",
          tableApi: "shipmentAnnuxTable",
          data: [
            {
              type: "form",
              schema: Annexdetails,
            },
            {
              type: "table",
              schema: AnnexPopupJson,
              subButtons: [
                {
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              visibleFields: [
                {
                  key: "SrNo",
                  label: "Sr No",
                  width: 150,
                },
                {
                  key: "exportAnnexDocumentName",
                  label: "Document Name",
                  width: 120,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "container",
      label: "Container",
      disabled: !hasJobNumber,
      schema: ContainerSchema,
      api: "container",
      type: "table",
      buttons: [
        {
          label: "Add New Container",
          icon: "LuPlus",
          action: "openForm",
        },
      ],
      expandedFields: [
        { key: "exportContainerSealDate", label: "Seal Date", width: 100 },
        {
          key: "exportContainerMoveDocType",
          label: "MoveDoc.Type",
          width: 100,
        },
        { key: "exportContainerMoveDocNo", label: "MoveCoc.No", width: 100 },
        { key: "exportContainerSealType", label: "Seal Type", width: 100 },
        {
          key: "exportContainerSealDeviceId",
          label: "Seal Device ID",
          width: 100,
        },
        { key: "exportContainerGrWtTrWt", label: "Gr-Wt+Tr-Wt", width: 100 },
        {
          key: "exportContainerGrossweightUnit",
          label: "Gross Weight Unit",
          width: 100,
        },
        {
          key: "exportContainerGrWtTrWtUnit",
          label: "Gr-Wt+Tr-Wt Unit",
          width: 100,
        },
      ],
      visibleFields: [
        { key: "exportContainerNo", label: "Container No", width: 150 },
        { key: "exportContainerSealNo", label: "Seal No", width: 150 },
        { key: "exportContainerType", label: "Type", width: 150 },
        {
          key: "exportContainerPktsStuffed",
          label: "Pkgs Stuffed",
          width: 150,
        },
        {
          key: "exportContainerGrossweight",
          label: "Gross Weight",
          width: 150,
        },
        { key: "exportContainerLocation", label: "Location", width: 150 },
      ],
    },
    {
      label: "Invoice",
      disabled: !hasJobNumber,
      type: "tab",
      component: InvoiceSummaryCard,
      componentProps: {
        customMessage: "Welcome to Invoice Tab",
        totalInvoiceValue: selectedInvoice?.totalInvoiceValue ?? 0,
        totalProductValue: selectedInvoice?.totalProductValue ?? 0,
        invoiceNumber: selectedInvoice?.exportInvoiceNumber ?? "-",
        toi: selectedInvoice?.exportInvoiceTOI ?? "-",
        currentInvoiceValue: selectedInvoice?.exportInvoiceValue ?? 0,
        currentProductValue: selectedInvoice?.exportInvoiceproductvalue ?? 0,
        currency: currencyName,
      },
      schema: InvoiceDialog,
      buttons: [
        {
          label: "View Product",
          icon: "LuBox",
          action: "viewProduct",
        },
        {
          label: "Declarations",
          onClick: () => {},
          icon: "LuFolder",
          sx: { color: "var(--brand-600)" },
        },
        {
          label: "Quick Entry",
          icon: "LuFileMinus",
          action: "openButtonSubDialog",
          subComponent: "InvoiceQuickEntry",
        },
        {
          label: "Add New Invoice",
          icon: "LuPlus",
          action: "openForm",
          ownerConfig: "invoiceMain",
        },
      ],
      subTabs: [
        {
          id: "invoiceMain",
          label: "Main",
          type: "table",
          schema: InvoiceDialog,
          api: "invoiceMain",
          visibleFields: [
            { key: "exportInvoiceNumber", label: "Invoice Number", width: 200 },
            { key: "exportInvoiceDate", label: "Date", width: 180 },
            { key: "exportInvoiceTOIPlace", label: "TOI & Place", width: 200 },
            { key: "exportCurrency", label: "Currency", width: 120 },
            { key: "exportInvoiceValue", label: "Invoice Value", width: 150 },
            {
              key: "exportInvoiceproductvalue",
              label: "Product Value (FOB)",
              width: 180,
            },
          ],
        },
        {
          id: "invoiceFreight",
          label: "Freight, Insurance & Other Changes",
          type: "tableWithFields",
          api: "invoiceFreight",
          attachData: "invoiceMain",
          disabled: !hasInvoice,
          visibleFields: [
            {
              key: "name",
              label: "Name",
              editable: false,
              height: "44px",
              width: "100px",
            },
            {
              key: "currency",
              label: "Currency",
              editable: true,
              width: "145px",
              height: "30px",
              disabled: true,
            },
            {
              key: "exchangerate",
              label: "Exchange Rate",
              editable: true,
              width: "145px",
              height: "30px",
              disabled: true,
            },
            {
              key: "rate",
              label: "Rate",
              editable: true,
              width: "140px",
              height: "30px",
              type: "number",
              disabled: (row, rowIndex) => [0, 1, 5].includes(rowIndex),
            },
            {
              key: "basevalue",
              label: "Base Value",
              editable: false,
              width: "130px",
              disabled: true,
            },
            {
              key: "amount",
              label: "Amount",
              editable: true,
              width: "130px",
              height: "30px",
              type: "number",
              disabled: (row, rowIndex) => [0, 1, 5].includes(rowIndex),
            },
          ],
        },
        {
          id: "invoiceBuyer",
          label: "Buyer/Third Party Information",
          type: "form",
          schema: InvoiceBuyer,
          api: "invoiceBuyer",
          disabled: !hasInvoice,
          attachData: "invoiceMain",
        },
        {
          id: "invoiceOtherInfo",
          label: "Other Information",
          type: "form",
          disabled: !hasInvoice,
          schema: InvoiceOtherDetails,
          attachData: "invoiceMain",
          api: "invoiceOtherinfo",
        },
      ],
    },
    {
      label: "Product",
      disabled: !hasInvoice,
      type: "tab",
      component: ProductTabBox,
      schema: ProductMain,
      titleButtons: [
        {
          label: "Summary Of this Product",
          action: "openDialog",
          component: "SummaryPopover",
          onClick: "handleOpen",
        },
      ],
      buttons: [
        {
          label : "Declarations",
          subComponent : "ProductDeclaration",
          action: "openButtonSubDialog",
        },
        {
          label: "Update Master",
          action: "updateMaster",
        },
        {
          label: "Add New Product",
          icon: "LuPlus",
          action: "openForm",
          ownerConfig: "productMain",
        },
      ],
      subTabs: [
        {
          id: "productMain",
          label: "Main",
          type: "table",
          schema: ProductMain,
          api: "productMain",
          replaceMasterId: "invoiceMain",
          visibleFields: [
            {
              key: "exportProductMainDescriptionId",
              label: "Description",
              editable: false,
              height: "44px",
              width: "100px",
            },
            {
              key: "exportProductMainRITCorHSNCodeId",
              label: "RITC",

              editable: true,
              width: "145px",
              height: "30px",
              disabled: true,
            },
            {
              key: "exportProductMainQuantity",
              label: "Quantity",
              editable: true,
              disabled: true,
              width: "145px",
              height: "30px",
            },
            {
              key: "exportProductMainSQCQuantity",
              label: "SQC Qty",
              editable: true,
              width: "140px",
              height: "30px",
            },
            {
              key: "exportProductMainUnitPrice",
              label: "Unit Price",
              editable: false,
              width: "130px",
            },
          ],
          expandedFields: [
            { key: "exportProductMainPer", label: "Per", width: 100 },
            { key: "exportProductMainAmount", label: "Amount", width: 100 },
          ],
        },
        {
          id: "productGeneral",
          label: "General",
          type: "form",
          disabled: !hasProduct,
          schema: ProductGeneral,
          api: "productGeneral",
          replaceMasterId: "productMain",
        },
        {
          id: "productSingleWindow",
          label: "Single Window",
          disabled: !hasProduct,
          type: "tab",
          checkBox: [
            {
              label: "Single Window",
            },
          ],
          subTabs: [
            {
              id: "additionalInfo",
              label: "Additional Info",
              api: "ProductAdditionalinfo",
              type: "table",
              buttons: [
                {
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              schema: ProductSinglewindowpop,
              replaceMasterId: "productMain",
              visibleFields: [
                {
                  key: "exportAdditionalinfoType",
                  label: "Type",
                  editable: false,
                  height: "44px",
                  width: "100px",
                },
                {
                  key: "exportAdditionalinfoQualifier",
                  label: "Qualifier",
                  editable: true,
                  width: "145px",
                  height: "30px",
                  disabled: true,
                },
                {
                  key: "exportAdditionalinfoCode",
                  label: "Code",
                  editable: true,
                  disabled: true,
                  width: "145px",
                  height: "30px",
                },
                {
                  key: "exportAdditionalinfoInformation",
                  label: "Information",
                  editable: true,
                  width: "140px",
                  height: "30px",
                },
                {
                  key: "exportAdditionalinfoMeasure",
                  label: "Measure",
                  editable: false,
                  width: "130px",
                },
                {
                  key: "exportAdditionalinfoMeasureUnit",
                  label: "Measure Unit",
                  editable: false,
                  width: "130px",
                },
              ],
              expandedFields: [
                { key: "exportProductMainPer", label: "Per", width: 100 },
                { key: "exportProductMainAmount", label: "Amount", width: 100 },
              ],
            },
            {
              id: "consitituents",
              label: "Consitituents",
              type: "table",
              api: "ProductConstituent",
              replaceMasterId: "productMain",
              buttons: [
                {
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              schema: ProductConsititpop,
              visibleFields: [
                { key: "exportConsituentName", label: "Name", width: 150 },
                { key: "exportConsituentCode", label: "Code", width: 150 },
                {
                  key: "exportConsituentPercentage",
                  label: "Percentage",
                  width: 150,
                },
                { key: "exportConsituentYield", label: "Yield %", width: 150 },
                { key: "exportConsituentActive", label: "Active", width: 150 },
              ],
            },
            {
              id: "controldetails",
              label: "Control Details",
              type: "table",
              api: "ProductControl",
              replaceMasterId: "productMain",
              buttons: [
                {
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              visibleFields: [
                { key: "exportControlType", label: "Type", width: 150 },
                { key: "exportControllocation", label: "Location", width: 150 },
                {
                  key: "exportControlStartDate",
                  label: "Start Date",
                  width: 150,
                },
                { key: "exportControlEndDate", label: "End Date", width: 150 },
                { key: "exportControlResult", label: "Result", width: 150 },
              ],
              schema: Control,
            },
            {
              id: "productiondetails",
              label: "Production Details",
              type: "table",
              api: "ProductDetails",
              replaceMasterId: "productMain",
              buttons: [
                {
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              schema: productiondetails,
              visibleFields: [
                { key: "exportProductBatchId", label: "Batch ID", width: 150 },
                {
                  key: "exportProductBatchQuantity",
                  label: "Batch Quantity",
                  width: 150,
                },
                {
                  key: "exportProductBatchunit",
                  label: "Batch Unit",
                  width: 150,
                },
                {
                  key: "exportProductManufacuturerDate",
                  label: "Manufacture Date",
                  width: 170,
                },
                {
                  key: "exportProductExpiryDate",
                  label: "Expiry Date",
                  width: 150,
                },
                {
                  key: "exportProductBestBeforeDate",
                  label: "Best Before Date",
                  width: 150,
                },
              ],
            },
          ],
        },
        {
          id: "deec",
          label: "DEEC",
          type:"formWithMultipleTable",
          tableReplaceMasterId: "productMain",
          tableReplaceMasterId2: "deecTable1",
          tableApi1:"productDEECTableOne",
          tableApi2:"productDEECTableTwo",
          disabled : !hasProduct,
          hide: !deecVisibleData?.includes(eximCode),
          data: [
            {
              id:"deecTable1",
              type: "form",
              schema: ProductDEECForm,
            },
            {
              id:"deecTable1",
              type: "table",
              schemaKey : "deec",
              schema: ProductDEECTable1,
              tableApiKey: "tableApi1",
              subButtons: [
                {
                   id:"table1",
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              visibleFields: [
                {
                  key: "srNo",
                  label: "Sr No",
                  width: 150,
                },
                {
                  key: "liCRefNo",
                  label: "Lic Ref No",
                  width: 150,
                },
                {
                  key: "deecRegNo",
                  label: "Reg No",
                  width: 120,
                },
                {
                  key: "deecRegDate",
                  label: "Reg Date",
                  width: 120,
                }
              ],
            },
            {
              id:"deecTable2",
              type: "table",
              schemaKey : "deecItem",
              schema: ProductDEECTable2,
              tableApiKey: "tableApi2",
              subButtons: [
                {
                   id:"table2",
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              visibleFields: [
                {
                  key: "srNo",
                  label: "Sr No",
                  width: 150,
                },
                {
                  key: "deecItemsnopartC",
                  label: "Item No Part C",
                  width: 120,
                },
                {
                  key: "deecItemDescription",
                  label: "Description",
                  width: 120,
                },
                { key: "deecItemQuantity", label: "Quantity", width: 100 },
                { key: "deecItemQuantityUnit", label: "Unit", width: 100 },
                {
                  key: "deecItemType",
                  label: "Item type",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          id: "dfrc",
          label: "DFRC",
          disabled: !hasProduct,
          type: "formWithTable",
          hide: !["Drawback And Zero Duty EPCG"].includes(eximCode),
          replaceMasterId: "productMain",
          tableReplaceMasterId: "dfrc",
          api: "productDFRCForm",
          tableApi: "productDFRCTable",
          data: [
            {
              type: "form",
              schema: ProductDRFCjson,
            },
            {
              type: "table",
              schema: ProductDRFC,
              subButtons: [
                {
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              visibleFields: [
                {
                  key: "sionSrNo",
                  label: "SION Sr No",
                  width: 150,
                },
                {
                  key: "sionIoNormSNo",
                  label: "SION IONorm SNo",
                  width: 120,
                },
                {
                  key: "quantity",
                  label: "Quantity",
                  width: 120,
                },
                { key: "unit", label: "Unit", width: 100 },
                { key: "itemType", label: "Item Type", width: 100 },
                {
                  key: "itemDescription",
                  label: "Item Description",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          id: "depb",
          disabled: !hasProduct,
          label: "DEPB",
          hide: !depbVisibleData.includes(eximCode),
          type: "formWithTable",
          replaceMasterId: "productMain",
          tableReplaceMasterId: "depb",
          api: "productDEPBForm",
          tableApi: "productDEPBTable",
          checkBox: [{ label: "This is DEPB Item" }],
          mapper: mapDEPBRequest,
          data: [
            {
              type: "form",
              schema: ProductDEPBjson,
            },
            {
              type: "table",
              schema: ProductDEPBpopjson,
              subButtons: [
                {
                  label: "add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              subcheckBox: [
                {
                  label:
                    "DEPB Credit based on item used in this product (DEPB Parent)",
                },
              ],
              visibleFields: [
                {
                  key: "exportProductDEPBProductgroup",
                  label: "Product Group",
                  width: 150,
                },
                {
                  key: "exportProductRateList",
                  label: "Rate List Sr No",
                  width: 120,
                },
                {
                  key: "exportProductDEPBRate",
                  label: "DEPB Rate",
                  width: 120,
                },
                { key: "exportProductDEPBQty", label: "DEBP Qty", width: 100 },
                { key: "exportProductDEPBUnit", label: "Unit", width: 100 },
                { key: "exportProductDEPBUnitQty", label: "%Qty", width: 100 },
                {
                  key: "exportProductCapValue",
                  label: "Cap Value",
                  width: 100,
                },
              ],
            },
          ],
          
        },
        {
          id: "productdrawback",
          label: "Draw Back",
          disabled: !hasProduct,
          type: "form",
          hide: !drawBackVisibleData.includes(eximCode),
          schema: ProductDrawTop,
          api: "productdrawback",
          replaceMasterId: "productMain",
          checkBox: [{ label: "Single Window" }],
        },
        {
          id: "epcg",
          label: "EPCG",
          disabled: !hasProduct,
          hide: !epcgVisibleData.includes(eximCode),
          type:"formWithMultipleTable",
          tableReplaceMasterId: "productMain",
          tableReplaceMasterId2: "epcgTable1",
          tableApi1:"productEPCGTableOne",
          tableApi2:"productEPCGTableTwo",
          data: [
            {
              id:"epcgTable1",
              type: "form",
              schema: ProductEPCGForm,
            },
            {
              id:"epcgTable1",
              type: "table",
              schemaKey : "exportProductEPCG",
              schema: ProductEPCGTable1,
              tableApiKey: "tableApi1",
              subButtons: [
                {
                   id:"table1",
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              visibleFields: [
                {
                  key: "srNo",
                  label: "Sr No",
                  width: 150,
                },
                {
                  key: "exportProductEPCGLicRefNo",
                  label: "Lic Ref No",
                  width: 150,
                },
                {
                  key: "exportProductEPCGEDiRegnNo",
                  label: "Reg No",
                  width: 120,
                },
                {
                  key: "exportProductEPCGDate",
                  label: "Reg Date",
                  width: 120,
                }
              ],
            },
            {
              id:"epcgTable2",
              type: "table",
              schemaKey : "exportProductEPCGItem",
              schema: ProductEPCGTable2,
              tableApiKey: "tableApi2",
              subButtons: [
                {
                   id:"table2",
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              visibleFields: [
                {
                  key: "srNo",
                  label: "Sr No",
                  width: 150,
                },
                {
                  key: "exportProductEPCGItemSnoPartC",
                  label: "Item No Part C",
                  width: 120,
                },
                {
                  key: "exportProductEPCGItemDescription",
                  label: "Description",
                  width: 120,
                },
                { key: "exportProductEPCGItemQuantity", label: "Quantity", width: 100 },
                { key: "exportProductEPCGItemUnit", label: "Unit", width: 100 },
                {
                  key: "exportProductEPCGItemType",
                  label: "Item type",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          id: "dfia",
          label: "DFIA",
          disabled: !hasProduct,
          hide: !dfiaVisibleData.includes(eximCode),
          type:"formWithMultipleTable",
          tableReplaceMasterId: "productMain",
          tableReplaceMasterId2: "dfiaTable1",
          tableApi1:"productDFIATableOne",
          tableApi2:"productDFIATableTwo",
          data: [
            {
              id:"dfiaTable1",
              type: "form",
              schema: ProductDFIAForm,
            },
            {
              id:"dfiaTable1",
              type: "table",
              schemaKey : "exportProductDFIA",
              schema: ProductDFIATable1,
              tableApiKey: "tableApi1",
              subButtons: [
                {
                   id:"table1",
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              visibleFields: [
                {
                  key: "srNo",
                  label: "Sr No",
                  width: 150,
                },
                {
                  key: "exportProductDFIALicRefNo",
                  label: "Lic Ref No",
                  width: 150,
                },
                {
                  key: "exportProductDFIAEDiRegnNo",
                  label: "Reg No",
                  width: 120,
                },
                {
                  key: "exportProductDFIADate",
                  label: "Reg Date",
                  width: 120,
                }
              ],
            },
            {
              id:"dfiaTable2",
              type: "table",
              schemaKey : "dfiaItem",
              schema: ProductDFIATable2,
              tableApiKey: "tableApi2",
              subButtons: [
                {
                   id:"table2",
                  label: "Add",
                  icon: "LuPlus",
                  onClick: "openForm",
                },
              ],
              visibleFields: [
                {
                  key: "srNo",
                  label: "Sr No",
                  width: 150,
                },
                {
                  key: "dfiaItemImportItemSno",
                  label: "Item No Part C",
                  width: 120,
                },
                {
                  key: "dfiaItemDescription",
                  label: "Description",
                  width: 120,
                },
                { key: "dfiaItemQuantity", label: "Quantity", width: 100 },
                { key: "dfiaItemUnit", label: "Unit", width: 100 },
                {
                  key: "dfiaItemType",
                  label: "Item type",
                  width: 100,
                },
              ],
            },
          ],
        },
        {
          id: "cessexduty",
          label: "Cess/Exp.Duty",
          api: "productCess",
          disabled: !hasProduct,
          type: "tableWithFields",
          checkBox: [
            {
              label: "CESS / Exp. Duty is leviable on this item",
            },
          ],
          sx: {
            pt: 1,
          },
          replaceMasterId: "productMain",
          visibleFields: [
            {
              key: "cessType",
              label: "Cess/Duty",
              width: 250,
              editable: true,
              subFields: [
                {
                  index: 0,
                  type: "dropdown",
                  width: "100%",
                  label: (row, rowIndex) => {
                    const labels = ["Export", "Cess", "Other", "Third"];
                    return labels[rowIndex] || "Export";
                  },
                  options: [
                    { value: "1(5%)", label: "1(5%)" },
                    { value: "1(10%)", label: "1(10%)" },
                    { value: "1(15%)", label: "1(15%)" },
                    { value: "1(Rs.8000/MTS)", label: "1(Rs.8000/MTS)" },
                    { value: "1(0%)", label: "1(0%)" },
                    { value: "1(8%)", label: "1(8%)" },
                  ],
                },
              ],
              getValue: (row) => row.cessType?.[0] || "",
              setValue: (row, value) => {
                if (!row.cessType) row.cessType = [];
                row.cessType[0] = value;
              },
            },
            {
              key: "cessrate",
              label: "Cess/Duty Rates",
              width: 600,
              editable: true,
              type: "composite",
              subFields: [
                {
                  index: 0,
                  type: "text",
                  width: "50px",
                  subType: "number",
                  label: true,
                },
                { index: 1, type: "static", value: "% Or Rs", label: true },
                {
                  index: 2,
                  type: "text",
                  placeholder: "Rate",
                  subType: "number",
                  label: true,
                },
                { index: 3, type: "static", value: "/", label: true },
                {
                  index: 4,
                  type: "text",
                  endpoint: "getQuantity",
                  name: "quantity",
                  label: true,
                },
              ],
              getValue: (row) => row.cessRate,
              setValue: (row, valueArray) => (row.cessRate = valueArray),
            },
            {
              key: "tariffValue",
              label: "Tariff Value (T.V.)",
              width: 350,
              editable: true,
              type: "composite",
              subFields: [
                {
                  index: 0,
                  type: "text",
                  width: "50px",
                  placeholder: "Value",
                  subType: "number",
                  label: true,
                },
                { index: 1, type: "static", value: "/", label: true },
                {
                  index: 2,
                  type: "text",
                  width: "50px",
                  endpoint: "getQuantity",
                  name: "quantity",
                  label: true,
                },
              ],
              visibleOnRowIds: ["row-2"],
            },
            {
              key: "quantity",
              label: "Qty for Cess/Duty",
              width: 160,
              editable: true,
              name: "quantity",
              type: "text",
              subFields: [
                {
                  index: 0,
                  type: "text",
                  placeholder: "Value",
                  subType: "number",
                  label: true,
                },
                { index: 1, type: "static", value: "Unit" },
              ],
              getValue: (row) => row.quantity?.[0] || "",
              setValue: (row, value) => (row.quantity[0] = value),
            },
            {
              key: "description",
              label: "Cess Description",
              width: 250,
              editable: true,
              type: "text",
              subFields: [
                { index: 0, type: "text", placeholder: "Value", label: true },
              ],
              getValue: (row) => row.description?.[0] || "",
              setValue: (row, value) => (row.description[0] = value),
            },
          ],
        },
        {
          id: "productQuota",
          label: "Quota",
          disabled: !hasProduct,
          type: "table",
          expandedFields: [],
          api: "ProductQuota",
          replaceMasterId: "productMain",
          subButtons: [
            {
              label: "Add",
              icon: "LuPlus",
              onClick: "openForm",
            },
          ],
          schema: ProductQuota,
          visibleFields: [
            {
              key: "exportProductQuotaCertificateNumber",
              label: "Quota Certificate No",
              width: 200,
              api: "invoicemainApi",
            },
            { key: "exportProductQuotaAgency", label: "Agency", width: 200 },
            {
              key: "exportProductQuotaExpiryDate",
              label: "Expiry Date",
              width: 200,
            },
            {
              key: "exportProductQuotaQuantity",
              label: "Quantity",
              width: 100,
            },
            { key: "exportProductQuotaUnit", label: "Unit", width: 100 },
          ],
        },
        {
          id: "productAreDetails",
          label: "ARE Details",
          disabled: !hasProduct,
          type: "table",
          subButtons: [
            {
              label: "Add",
              icon: "LuPlus",
              onClick: "openForm",
            },
          ],
          schema: ProductARE,
          visibleFields: [
            {
              key: "areNo",
              label: "ARE Number",
              width: 120,
            },
            { key: "areDate", label: "ARE Date", width: 100 },
            { key: "areCommissionerate", label: "Commissionerate", width: 120 },
            { key: "areDivision", label: "Division", width: 60 },
            { key: "areRange", label: "Range", width: 60 },
            { key: "areRemark", label: "Remark", width: 100 },
          ],
          api: "productAreDetails",
          replaceMasterId: "productMain",
        },
        {
          id: "jobwork",
          label: "Job Work",
          api: "jobwork",
          hide: true,
          disabled: !hasProduct,
          replaceMasterId: "productMain",
          schema: ProductJobWork,
          type: "table",
          subButtons: [
            {
              label: "Add",
              icon: "LuPlus",
              onClick: "openForm",
            },
          ],
          visibleFields: [
            { key: "exportProductJobWorkNotnno", label: "Notn.No", width: 80 },
            {
              key: "exportProductJobWorkBENumber",
              label: "BE Number",
              width: 150,
            },
            { key: "exportProductJobWorkDate", label: "Date", width: 120 },
            {
              key: "exportProductJobWorkInvSrNo",
              label: "Inv Sr No",
              width: 120,
            },
            {
              key: "exportProductJobWorkQuantity",
              label: "Quantity",
              width: 100,
            },
            { key: "exportProductJobWorkUnit", label: "Unit", width: 100 },
          ],
          expandedFields: [
            {
              key: "exportProductJobWorkActualInvSrNo",
              label: "Actual Inv No",
              width: 100,
            },
            {
              key: "exportProductJobWorkItemSrNo",
              label: "Item Sr No",
              width: 100,
            },
            {
              key: "exportProductJobWorkImportedAt",
              label: "Imported At",
              width: 100,
            },
          ],
        },
        {
          id: "productReExport",
          label: "Re-Export",
          type: "form",
          disabled: !hasProduct,
          schema: ProductReExportSchema,
          api: "productReExport",
          replaceMasterId: "productMain",
          checkBox: [{ label: "This is ReExport Item" }],
        },
        {
          id: "productOtherdetails",
          label: "Other Details",
          type: "form",
          disabled: !hasProduct,
          api: "productOtherInfo",
          schema: ProductOther,
          replaceMasterId: "productMain",
        },
        {
          id: "productDucInfo",
          label: "DUC Info",
          type: "table",
          disabled: !hasProduct,
          subButtons: [
            {
              label: "Add",
              icon: "LuPlus",
              onClick: "openForm",
            },
          ],
          subcheckBox: [{ label: "This Item is DUC" }],
          schema: ProductDUCInfo,
          expandedFields: [
            {
              key: "exportProductDUCRefNoBEfieldat",
              label: "BE Filed at",
              width: 100,
            },
            {
              key: "exportProductDUCRefNoBEinvsr",
              label: "BE Inv.Sr",
              width: 100,
            },
            {
              key: "exportProductDUCRefNoBEitemsr",
              label: "BE Item Sr.",
              width: 100,
            },
          ],
          visibleFields: [
            { key: "SrNo", label: "Sr No.", width: 150 },
            { key: "exportProductDUCRefNo", label: "DUC Ref No.", width: 150 },
            {
              key: "exportProductDUCRefType",
              label: "Export Type",
              width: 150,
            },
            {
              key: "exportProductDUCRefNoSBDate",
              label: "SB Date",
              width: 150,
            },
            { key: "exportProductDUCRefNoBENo", label: "BE No.", width: 150 },
            {
              key: "exportProductDUCRefNoBEDate",
              label: "BE Date",
              width: 150,
            },
          ],

          api: "productDucInfo",
          replaceMasterId: "productMain",
        },
        {
          id: "productDocInfo",
          label: "DOC Info",
          disabled: !hasProduct,
          type: "table",
          subButtons: [
            {
              label: "Add",
              icon: "LuPlus",
              onClick: "openForm",
            },
          ],
          schema: ProductDOCInfo,
          visibleFields: [
            { key: "SrNo", label: "Sr No.", width: 150 },
            { key: "exporterProductDocType", label: "Doc Type", width: 150 },
            {
              key: "exporterProductDocAgencyCode",
              label: "Agency Code",
              width: 150,
            },
            {
              key: "exporterProductDocAgencyName",
              label: "Agency Name",
              width: 150,
            },
            {
              key: "exporterProductDocDocumentName",
              label: "Document Name",
              width: 150,
            },
          ],
          api: "productDocInfo",
          replaceMasterId: "productMain",
        },
      ],
    },
    {
      id: "exchRate",
      label: "Exch. Rate",
      disabled: !hasJobNumber,
      api: "exchangeRate",
      type: "tableWithFields",
      visibleFields: [
        { key: "code", editable: false, height: "44px", width: "100px" }, // shows USD
        {
          key: "custExchRate",
          label: "Cust Exch Rate",
          editable: true,
          width: "145px",
          height: "30px",
          disabled: true,
          parentKey: "custom", // nested inside row.custom
          type: "number", // important!
        },
        {
          key: "nonStdCurr",
          label: "Non Std.Curr",
          editable: true,
          disabled: true,
          width: "145px",
          height: "30px",
          type: "number", // important!
        },
        {
          key: "exRate",
          label: "Ex. Rate",
          editable: true,
          width: "140px",
          height: "30px",
          parentKey: "custom",
          type: "number", // important!
        },
        { key: "cfx", label: "CFX", editable: false, width: "130px" },
        {
          key: "exRateCfx",
          label: "Ex. Rate",
          editable: false,
          width: "130px",
          height: "30px",
        },
        {
          key: "agentExRate",
          label: "Agent Ex.Rate",
          editable: true,
          width: "130px",
          height: "30px",
          parentKey: "revenue",
          type: "number", // important!
        },
        {
          key: "cfxAgent",
          label: "CFX",
          editable: false,
          width: "130px",
          height: "30px",
          parentKey: "revenue",
        },
        {
          key: "exRateCost",
          label: "Ex. Rate",
          editable: false,
          width: "130px",
          height: "30px",
          parentKey: "cost",
        },
        {
          key: "cost",
          label: "Cost",
          editable: true,
          width: "130px",
          height: "30px",
          parentKey: "cost",
          type: "number", // important!
        },
      ],
      groupedHeaders: [
        { label: "Code", colSpan: 1, height: "44px" },
        { label: "Custom", colSpan: 2, height: "44px" },
        { label: "Revenue", colSpan: 6, height: "44px" },
        { label: "Cost", colSpan: 2, height: "44px" },
      ],
      actions: [],
    },
    {
      id: "esanchit",
      label: "eSanchit",
      type: "table",
      api: "esanchit",
      schema: ProductSanchit,
      extraApi: "eSanchitFilter",

      // schema: ProductSanchitFilter,
      visibleFields: [
        { key: "eSanchitDocumentLevel", label: "Doc.Level", width: 100 },
        { key: "eSanchitInvsrNo", label: "Inv.Sr.No", width: 150 },
        { key: "eSanchitItemSrNo", label: "Item Sr.No", width: 150 },
        { key: "eSanchitIRN", label: "Doc.IRN", width: 150 },
        { key: "eSanchitDocumentType", label: "Doc.Type", width: 200 },
      ],
      expandedFields: [
        { key: "eSanchitDocumentRefNo", label: "Doc.Ref.No", width: 150 },
        { key: "eSanchitIcegateId", label: "ICEGATE ID", width: 200 },
        { key: "eSanchitDateofIssue", label: "Doc.Issue date", width: 200 },
        { key: "eSanchitExpiryDate", label: "Doc.Expiry date", width: 200 },
        { key: "eSanchitPlaceofIssue", label: "Doc.Issued at", width: 200 },
        {
          key: "eSanchitDatetimeupload",
          label: "Doc.Upload date-time",
          width: 200,
        },
        {
          key: "eSanchitICegateFileName",
          label: "ICEGATE File name",
          width: 200,
        },
        { key: "eSanchitFileType", label: "File Type", width: 200 },
      ],
      buttons: [
        {
          label: "Filter",
          icon: "LuFilter",
          action: "openForm",
          schema: ProductSanchitFilter,
          extraApi: "eSanchitFilter",
          disabled: formData?.esanchit?.length === 0,
        },
        {
          label: "Add",
          icon: "LuPlus",
          action: "openForm",
        },
      ],
      actions: [
        {
          icon: "FiEdit2",
          title: "Edit",
          handler: "handleEdit", // string reference to function
        },
        {
          icon: "LuTrash2",
          title: "Delete",
          handler: "handleRemove",
        },
        {
          icon: "HiOutlineEye",
          title: "View",
          handler: "handleView",
          show: (row) =>
            row?.eSanchitAttachmentId || row?.eSanchitAttachment?.filePath,
        },
      ],
      disabled: !hasJobNumber,
    },

    { label: "ICEGATE", disabled: true },
    { label: "E-Doc", disabled: true },
    {
      id: "requirement",
      label: "Requirements",
      schema: Requirement,
      api: "requirement",
      type: "table",

      buttons: [
        {
          label: "Re-Initialize",
          action: "reInitializeRequirement",
        },
        {
          label: "Add",
          icon: "LuPlus",
          action: "openForm",
        },
      ],

      visibleFields: [
        {
          key: "exportRequirementDocumentName",
          label: "Document Name",
          width: 180,
          editable: true,
        },
        { key: "exportRequirementDate", label: "Date", width: 200 },
      ],
      disabled: !hasJobNumber,
    },
    {
      id: "udf",
      label: "UDF",
      disabled: !hasJobNumber,
      schema: Udf,
      api: "udf",
      type: "form",
    },
    { 
      id:"tracking",
      label: "Tracking",
      disabled: !hasJobNumber,
      schema:Trackingschema,
      component:Tracking,
      api:"TrackingDetails",
      mapper:mapMilestoneToApi,
     },
    {
      id: "exportNotes",
      label: "Notes",
      type: "table",
      api: "exportNotes",
      schema: Note,
      visibleFields: [
        { key: "exportNoteDate", label: "Date", width: 200 },
        { key: "exportNotes", label: "Notes", width: 200 },
      ],

      buttons: [
        {
          label: "Add Notes",
          icon: "LuPlus",
          action: "openForm",
        },
      ],

      actions: [
        {
          icon: "FiEdit2",
          title: "Edit",
          handler: "handleEdit", // string reference to function
        },
        {
          icon: "LuTrash2",
          title: "Delete",
          handler: "handleRemove",
        },
        {
          icon: "HiOutlineEye",
          title: "View",
          handler: "handleView",
          show: (row) =>
            row?.exportNoteAttachmentId || row?.exportNoteAttachment?.filePath,
        },
      ],
      disabled: !hasJobNumber,
    },
    {
      id: "exporthistory",
      label: "History",
      api: "exporthistory",
      type: "table",
      visibleFields: [
        { key: "exportHistoryDateTime", label: "Date & Time", width: 150 },
        { key: "userName", label: "User ID", width: 150 },
        { key: "exportHistoryLocation", label: "Location", width: 130 },
        { key: "exportHistoryAction", label: "Action", width: 130 },
        { key: "exportHistoryRemarks", label: "Remarks", width: 190 },
      ],
      disabled: !hasJobNumber,
      actions: [],
      buttons: [
        {
          label: "Refresh",
          action: "Refresh",
        },
      ],
    },
  ];
};

export default CreateNewJobSidebarItems;
